// extracted by mini-css-extract-plugin
module.exports = {"checkCircleOutlined":"AlertaPorRetraso_checkCircleOutlined__20aQ3","closeCircleOutlined":"AlertaPorRetraso_closeCircleOutlined__1IrAr"};